// extracted by mini-css-extract-plugin
export default {"pColor":"edit-profile-screen_pColor__G4uMn"};